.cuts-fieldset {
  border: none;
  margin: 0;
  padding: 0;
}

.new_cut_to_size_options.galv-cuts input[type=number] {
  text-align: left;
}

.new_cut_to_size_options.galv-cuts input[type=number].input-length {
  width: 64px;
}

.cuts-fieldset-inner .cts-fields {
  margin-left: 0;
  max-width: none;
  width: 100%;
}

.cts-remove .remove-cut {
  background: none;
  border: none;
  cursor: pointer;
}

.cuts-fieldset .Splashback-fields {
  margin-right: 3rem;
}
@media (min-width: 960px) {
  .cuts-fieldset .Splashback-fields {
    margin-right: 0;
  }
}

@media (min-width: 960px) {
  .galv-cuts-form {
    margin-left: 2rem;
  }
}
/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbImlucHV0cy5zY3NzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBO0VBQ0U7RUFDQTtFQUNBOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFOzs7QUFHRjtFQUNFO0VBQ0E7RUFDQTs7O0FBR0Y7RUFDRTtFQUNBO0VBQ0E7OztBQUlBO0VBQ0U7O0FBRUE7RUFIRjtJQUlJOzs7O0FBS047RUFDRTtJQUNFIiwic291cmNlc0NvbnRlbnQiOlsiLmN1dHMtZmllbGRzZXQge1xuICBib3JkZXI6IG5vbmU7XG4gIG1hcmdpbjogMDtcbiAgcGFkZGluZzogMDtcbn1cblxuLm5ld19jdXRfdG9fc2l6ZV9vcHRpb25zLmdhbHYtY3V0cyBpbnB1dFt0eXBlPVwibnVtYmVyXCJdIHtcbiAgdGV4dC1hbGlnbjogbGVmdDtcbn1cblxuLm5ld19jdXRfdG9fc2l6ZV9vcHRpb25zLmdhbHYtY3V0cyBpbnB1dFt0eXBlPVwibnVtYmVyXCJdLmlucHV0LWxlbmd0aCB7XG4gIHdpZHRoOiA2NHB4O1xufVxuXG4uY3V0cy1maWVsZHNldC1pbm5lciAuY3RzLWZpZWxkcyB7XG4gIG1hcmdpbi1sZWZ0OiAwO1xuICBtYXgtd2lkdGg6IG5vbmU7XG4gIHdpZHRoOiAxMDAlO1xufVxuXG4uY3RzLXJlbW92ZSAucmVtb3ZlLWN1dCB7XG4gIGJhY2tncm91bmQ6IG5vbmU7XG4gIGJvcmRlcjogbm9uZTtcbiAgY3Vyc29yOiBwb2ludGVyO1xufVxuXG4uY3V0cy1maWVsZHNldCB7XG4gIC5TcGxhc2hiYWNrLWZpZWxkcyB7XG4gICAgbWFyZ2luLXJpZ2h0OiAzcmVtO1xuXG4gICAgQG1lZGlhIChtaW4td2lkdGg6IDk2MHB4KSB7XG4gICAgICBtYXJnaW4tcmlnaHQ6IDA7XG4gICAgfVxuICB9XG59XG5cbkBtZWRpYSAobWluLXdpZHRoOiA5NjBweCkge1xuICAuZ2Fsdi1jdXRzLWZvcm0ge1xuICAgIG1hcmdpbi1sZWZ0OiAycmVtO1xuICB9XG59XG4iXX0= */